module.exports = __webpack_public_path__ + "static/04-cd50f687e17198c71ca325cf6f0dba5a.jpg";